import * as React from 'react';

import { GRADIENT_ARROW_WIDTH } from '../../constants/arrows';
import { GradientArrowLeft } from '../GradientArrowLeft';
import { GradientArrowRight } from '../GradientArrowRight';
import { VerticalSlider } from '../VerticalSlider';

export const ChipsLayout: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return (
    <div>
      <VerticalSlider rightArrow={GradientArrowRight} leftArrow={GradientArrowLeft} scrollOffset={GRADIENT_ARROW_WIDTH}>
        {children}
      </VerticalSlider>
    </div>
  );
};
